module.exports = __webpack_public_path__ + "img/Marketing_case_pic06.580ba46f.png";